import { render, staticRenderFns } from "./ItemMarket.vue?vue&type=template&id=31e1496a&scoped=true"
import script from "./ItemMarket.vue?vue&type=script&lang=js"
export * from "./ItemMarket.vue?vue&type=script&lang=js"
import style0 from "./ItemMarket.vue?vue&type=style&index=0&id=31e1496a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1496a",
  null
  
)

export default component.exports